export const padaitem = [
    
    {
        "anio" : "PADA 2026",
        "url": "/pdf/PADA2026.pdf"
    },
     {
        "anio" : "PADA 2025",
        "url": "/pdf/PADA2025.pdf"
    },
    
]